import { createFeature, createReducer, createSelector, on, resultMemoize } from '@ngrx/store'
import * as UserActions from './user.actions'
import { User } from './user.model'
import { ThemeService } from '../services/theme.service'
import { inject } from '@angular/core'

export const userFeatureKey = 'user'

export interface UserState {
  isAuthenticated: boolean
  user: User | null
  statusMessage: string
  isLoading: boolean
  hasError: boolean
  impersonation: boolean
  urlAfterLogin: string
}

export const initialState: UserState = {
  isAuthenticated: false,
  user: null,
  statusMessage: '',
  isLoading: false,
  hasError: false,
  impersonation: false,
  urlAfterLogin: '/home',
}

export const reducer = createReducer(
  initialState,
  on(UserActions.loginUser, (state) => {
    return {
      ...state,
      hasError: false,
      statusMessage: '',
      isLoading: true
    }
  }),
  on(UserActions.loginComplete, (state, {user}) => {
    const themeService = new(ThemeService)
    themeService.setTheme(themeService.storedTheme)
    return {
      ...state,
      user,
      isAuthenticated: true,
      hasError: false,
      statusMessage: '',
      isLoading: false
    }
  }),
  on(UserActions.loginError, (state, {error}) => {
    return {
      ...state,
      isAuthenticated:false,
      hasError: true,
      statusMessage: error,
      isLoading: false
    }
  }),
  on(UserActions.logout, (state, {error}) => {
    return {
      ...initialState,
      statusMessage: error
    }
  }),
  on(UserActions.logoutByIP, (state, {error}) => {
    return {
      ...initialState,
      statusMessage: error
    }
  }),
  on(UserActions.setReturnToURL, (state, {urlAfterLogin}) => {
    return {
      ...state,
      urlAfterLogin,
    }
  }),
  on(UserActions.updateUser, (state, {user}) => {
    return {
      ...state,
      user
    }
  }),
  on(UserActions.updateUserHasSeen, (state, {label}) => {
    let result = structuredClone(state)
    result.user!.hasSeen[label] = true
    return result
  }),
  on(UserActions.updateUserHomePageSections, (state, {sections}) => {
    let result = structuredClone(state)
    result.user!.homePageSections = structuredClone(sections)
    return result
  }),
  on(UserActions.updateUserNextGenCSO, (state, {nextGenCSO}) => {
    let result = structuredClone(state)
    result.user!.nextGenCSO = nextGenCSO
    return result
  }),
  on(UserActions.loginDemoUser, (state) => {
    if (state.user?.CustId == "12041") {
      window.open("/situations", "_blank")
      window.open("/data/plans", "_blank")
      window.open("/organizations", "_blank")
      window.open("/people", "_blank")
      window.open("/documents", "_blank")
    }
    return state
  }),
  on(UserActions.impersonateUser, (state) => {
    let result = structuredClone(state)
    result.user!.impersonation = true
    return result
  })
)

export const userFeature = createFeature({
  name: userFeatureKey,
  reducer,
  extraSelectors: ({selectIsAuthenticated, selectUserState, selectUser}) => ({
    isLoggedIn: createSelector(
      selectUserState,
      (state) => state.isAuthenticated
    ),
    nextURL: createSelector(
      selectUserState,
      (state) => state.urlAfterLogin
    ),
  })
})

export const {
  isLoggedIn,
  nextURL,
  selectUser,
} = userFeature